import React from 'react';
import './css/VideoProcessing.css';
import { useSelector } from 'react-redux';
import { selectCompletedUploads } from '../app/redux/slices/uploadsSlice';

const VideoProcessing = ({ progress, stage, isCurrentStageLoading }) => {
  const completedUploads = useSelector(selectCompletedUploads);
  const stages = [
    'Analyzing video content',
    'Detecting key moments',
    'Scoring viral potential',
    'Generating clip suggestions',
    'Finalizing clips'
  ];

  // Calculate current stage index based on progress
  const currentStageIndex = Math.min(
    Math.floor(progress / (100 / stages.length)),
    stages.length - 1
  );
  
  // Use the calculated stage or the provided stage if it exists
  const currentStage = stage || stages[currentStageIndex];

  // Check if completedUploads exists and has items
  if (completedUploads && completedUploads.length > 0) {
    
    return (
      <div className="video-processing">
        <h2>Processing Your Video</h2>
        
        <div className="progress-container">
          <div className="progress-bar">
            <div className="progress" style={{ width: `${progress}%` }}></div>
          </div>
          <div className="progress-percentage">{progress}%</div>
        </div>
        
        <div className="processing-stages">
          {stages.map((s, index) => (
            <div 
              key={index} 
              className={`processing-stage ${
                index < currentStageIndex 
                  ? 'completed' 
                  : index === currentStageIndex 
                    ? 'current' 
                    : ''
              }`}
            >
              <div className="stage-indicator">
                {index < currentStageIndex 
                  ? '✓' 
                  : index === currentStageIndex 
                    ? '●' 
                    : '○'}
              </div>
              <div className="stage-name">
                {s}
                {index === currentStageIndex && isCurrentStageLoading && (
                  <span className="loading-dots">
                    <span className="dot">.</span>
                    <span className="dot">.</span>
                    <span className="dot">.</span>
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  } else {
    // Return a placeholder or null when no completed uploads
    return (
      <div className="video-processing-placeholder">
        <p>Waiting for video uploads to complete...</p>
      </div>
    );
  }
};

export default VideoProcessing;